import React, { Children, cloneElement } from 'react'
import PropTypes from 'prop-types'
import useFeatureFlags from '../../hooks/useFeatureFlags'

import styles from './styles'

const FeatureFlag = ({ flag, children }) => {
  const { data: enabledFeatures = [], isLoading: isEnabledFeaturesLoading } = useFeatureFlags()
  const isFeatureEnabled = !isEnabledFeaturesLoading && enabledFeatures.includes(flag)

  if (isEnabledFeaturesLoading) return <span className={styles.accessiblyHidden}>Loading</span>
  return Children.map(children, child => {
    return typeof child.type !== 'string' && cloneElement(child, { isFeatureEnabled })
  })
}

const { string, arrayOf, node, oneOfType } = PropTypes
FeatureFlag.propTypes = {
  flag: string.isRequired,
  children: oneOfType([arrayOf(node), node]),
}

export default FeatureFlag
